import { cva, VariantProps } from "class-variance-authority";
import clsx from "clsx";
import React, { ReactNode } from "react";

import { ButtonHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  children: ReactNode;
}

const Button = ({
  children,
  className,
  variant,
  size,
  ...props
}: ButtonProps) => {
  return (
    <button
      className={twMerge(clsx(buttonVariants({ variant, size, className })))}
      {...props}
    >
      {children}
    </button>
  );
};

const buttonVariants = cva(
  "rounded-[32px] border-transparent cursor-pointer py-[5px] px-[11px] h-max",
  {
    variants: {
      variant: {
        primary: "bg-primary text-primaryWhite hover:bg-primaryHover",
        danger: "bg-error text-primaryWhite",
      },
      size: {
        sm: "text-sm",
        md: "text-[1rem]",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
    },
  }
);

export default Button;
